import { useEffect, useState } from "react";
import { AnimatePresence, motion, animate } from "framer-motion";
import { EASE } from "@/components/motion/Reveal";
import { SHOW_INTRO, markIntroSeen } from "@/lib/intro";

const B = ["11110", "10001", "10001", "11110", "10001", "10001", "11110"];
const PIXELS = B.flatMap((row, r) => row.split("").map((c, i) => (c === "1" ? [i, r] : null)).filter(Boolean));

const Mark = () => (
  <svg viewBox="0 0 32 32" className="h-24 w-24 sm:h-28 sm:w-28">
    {PIXELS.map(([i, r], k) => (
      <motion.rect key={k} x={7.4 + i * 3.6} y={3.4 + r * 3.6} width="3.2" height="3.2" fill="#00F0FF" initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.1 + k * 0.035, duration: 0.35, ease: EASE }} style={{ transformOrigin: "center", transformBox: "fill-box" }} />
    ))}
    <motion.rect x="21.8" y="3.4" width="3.2" height="3.2" fill="#FF2A40" initial={{ opacity: 0 }} animate={{ opacity: [0, 1, 0.3, 1] }} transition={{ delay: 0.95, duration: 0.5 }} />
  </svg>
);

export const Preloader = () => {
  const [show, setShow] = useState(SHOW_INTRO);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!show) return;
    const c = animate(0, 100, { duration: 1.5, ease: [0.65, 0, 0.35, 1], onUpdate: (v) => setCount(Math.round(v)) });
    const t = setTimeout(() => { markIntroSeen(); setShow(false); }, 1750);
    return () => { c.stop(); clearTimeout(t); };
  }, [show]);
  return (
    <AnimatePresence>
      {show && (
        <motion.div exit={{ clipPath: "inset(0 0 100% 0)" }} transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }} style={{ clipPath: "inset(0 0 0% 0)" }} className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-ink-950" data-testid="preloader">
          <Mark />
          <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.6 }} className="mt-8 font-mono text-[11px] uppercase tracking-[0.4em] text-slate-400">Brewer Amusement Co.</motion.p>
          <div className="absolute bottom-10 left-6 right-6 flex items-end justify-between sm:left-12 sm:right-12">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600">McMinnville, TN</span>
            <span className="font-display text-6xl font-black tabular-nums text-white sm:text-8xl">{count}<span className="text-volt">%</span></span>
          </div>
          <div className="absolute bottom-0 left-0 h-px bg-volt" style={{ width: `${count}%` }} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
